// extracted by mini-css-extract-plugin
export default {"products":"CatAddCards_products__3-Pqs","card_image":"CatAddCards_card_image__tPe-a","read_more_button":"CatAddCards_read_more_button__2AcY1"};